import React from "react";
import './start.css';

const Start = () =>{
 return(
<section className="g-wrapper">
    <div className="paddings inerWidth g-container">
        <div className="flexColCenter inner-container">
            <span className="primaryText">Get started with Homyz</span>
            <span className="secondaryText">Subscribe and find super attractive price quotes from us.
<br /> Find your residence soon</span>
        <button className="button">
            <a href="mailto:mohammadkhan6543210@gmail.com">Get Started</a>
        </button>
        </div>
    </div>
</section>

 );
}

export default Start;